<!-- <ngx-spinner bdColor="rgba(255, 140, 19, 1)" color="#FFF"  type="ball-scale-multiple"></ngx-spinner> -->
<div class="loader-body" *ngIf="loader">
    <div class="loader">
        <div>
            <ul>
                <li>
                    <svg fill="currentColor" viewBox="0 0 90 120">
                        <path
                            d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z">
                        </path>
                    </svg>
                </li>
                <li>
                    <svg fill="currentColor" viewBox="0 0 90 120">
                        <path
                            d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z">
                        </path>
                    </svg>
                </li>
                <li>
                    <svg fill="currentColor" viewBox="0 0 90 120">
                        <path
                            d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z">
                        </path>
                    </svg>
                </li>
                <li>
                    <svg fill="currentColor" viewBox="0 0 90 120">
                        <path
                            d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z">
                        </path>
                    </svg>
                </li>
                <li>
                    <svg fill="currentColor" viewBox="0 0 90 120">
                        <path
                            d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z">
                        </path>
                    </svg>
                </li>
                <li>
                    <svg fill="currentColor" viewBox="0 0 90 120">
                        <path
                            d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z">
                        </path>
                    </svg>
                </li>
            </ul>
        </div><span>{{'loading' | translate}}</span>
    </div>
</div>



<header class="rbt-header rbt-header-9" *ngIf="!loader">
    <div class="rbt-sticky-placeholder"></div>

    <div class="rbt-header-top rbt-header-top-1 header-space-betwween bg-not-transparent bg-color-darker top-expended-activation">
        <div class="container-fluid">
            <div class="top-expended-wrapper">
                <div class="top-expended-inner rbt-header-sec align-items-center ">
                    <div class="rbt-header-sec-col rbt-header-right mt_md--10 mt_sm--10">
                        <div class="rbt-header-content justify-content-start justify-content-lg-end">
                            <div class="rbt-separator d-none d-xl-block"></div>

                            <div class="header-info">
                                <ul class="rbt-dropdown-menu switcher-language">
                                    <li class="has-child-menu">
                                        <a>
                                            <span class="menu-item">{{'lang' | translate}}</span>
                                            <i class="right-icon feather-chevron-down"></i>
                                        </a>
                                        <ul class="sub-menu lan-sub">
                                            <li (click)="changeLangAR()">
                                                <a>
                                                    <span class="menu-item langAr">عربي</span>
                                                </a>
                                            </li>
                                            <li (click)="changeLangEn()">
                                                <a>
                                                    <span class="menu-item">English</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="rbt-header-wrapper  header-not-transparent header-sticky">
        <div class="container">
            <div class="mainbar-row rbt-navigation-end align-items-center">
                <div class="header-left rbt-header-content">
                    <div class="header-info">
                        <div class="logo">
                            <a routerLink="/home">
                                <img src="assets/images/logo/learnyhomelogo.png" alt="Education Logo Images">
                            </a>
                        </div>
                    </div>
                </div>

                <div class="rbt-main-navigation d-none d-xl-block">
                    <nav class="mainmenu-nav">
                        <ul class="mainmenu">
                            <li class="with-megamenu has-menu-child-item position-static">
                                <a routerLink="/home">{{'home' | translate}}</a>
                            </li>

                            <li class="with-megamenu has-menu-child-item">
                                <a routerLink="/courses">{{'Courses' |translate}}</a>
                            </li>

                            <li class="with-megamenu has-menu-child-item">
                                <a routerLink="/about-us">{{'About Us' | translate}}</a>
                            </li>

                            <li class="with-megamenu has-menu-child-item">
                                <a routerLink="/contact">{{'Contact Us' | translate}}</a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="header-right">
                    <div class="rbt-btn-wrapper d-none d-xl-block" style="margin: 0 10px;" routerLink="/register"
                        *ngIf="!this.tokenValid">
                        <a class="rbt-btn  btn-gradient btn-sm hover-transform-none">
                            <span data-text="Join Now">{{'Join Now' | translate}}</span>
                        </a>
                    </div>

                    <div class="rbt-btn-wrapper d-none d-xl-block" routerLink="/login" *ngIf="!this.tokenValid">
                        <a class="rbt-btn btn-gradient btn-sm hover-transform-none">
                            <span data-text="Sign In">{{'signIn' | translate}}</span>
                        </a>
                    </div>

                    <!-- <div>
                        <a *ngIf="!dir" class="nav-links" (click)="changeLangAR()" style="cursor: pointer;">عربي</a>
                        <a *ngIf="dir" class="nav-links" (click)="changeLangEn()" style="cursor: pointer;">English</a>
                    </div> -->
                </div>

                <div class="mobile-menu-bar d-block d-xl-none">
                    <div class="hamberger" (click)="showMobileMenu()">
                        <button class="hamberger-button rbt-round-btn">
                            <i class="feather-menu"></i>
                        </button>
                    </div>
                </div>

                <div class="header-info" *ngIf="this.tokenValid">


                    <ul class="quick-access" *ngIf="this.isTeacher === 'false'">
                        <li class="access-icon rbt-mini-cart" routerLink="/cart">
                            <a class="rbt-cart-sidenav-activation rbt-round-btn" title="{{'Cart' | translate}}">
                                <i class="feather-shopping-cart" style="margin-left: 0px !important;"></i>
                            </a>
                        </li>

                        <li class="access-icon rbt-mini-cart" (click)="showNotificationSide()">
                            <a class="rbt-cart-sidenav-activation rbt-round-btn">
                                <i class="feather-bell" style="margin-left: 0px !important;"></i>
                                <span class="rbt-cart-count">{{studNotificationsNo}}</span>
                            </a>
                        </li>

                        <li class="account-access rbt-user-wrapper right-align-dropdown d-none d-xl-block">
                            <a><i class="feather-user"></i>{{'account' | translate}}</a>
                            <div class="rbt-user-menu-list-wrapper">
                                <div class="inner">
                                    <div class="rbt-admin-profile">
                                        <div class="admin-thumbnail">
                                            <img style="aspect-ratio: 1 / 1;" [src]="this.baseService.appUrl + this.profileImg" onerror=" this.onerror=null;this.src='assets/images/team/avatar.jpg';" alt="User Images">
                                        </div>
                                        <div class="admin-info">
                                            <span class="name">{{this.userFullName}}</span>
                                            <a class="rbt-btn-link color-primary"
                                                (click)="viewStudProfile(this.studentId)">{{'View Profile' |
                                                translate}}</a>
                                        </div>
                                    </div>
                                    <ul class="user-list-wrapper">
                                        <li>
                                            <a (click)="viewStudCourses(this.studentId)">
                                                <i class="feather-monitor"></i>
                                                <span>{{'Courses' | translate}}</span>
                                            </a>
                                        </li>
                                    </ul>
                                    <!-- <ul class="user-list-wrapper">
                                        <li>
                                            <a (click)="viewWishlist(this.studentId)">
                                                <i class="feather-heart"></i>
                                                <span>{{'fav' | translate}}</span>
                                            </a>
                                        </li>
                                    </ul> -->
                                    <ul class="user-list-wrapper">
                                        <li>
                                            <a (click)="viewCart()">
                                                <i class="feather-shopping-cart"></i>
                                                <span>{{'Cart' | translate}}</span>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul class="user-list-wrapper">
                                        <li>
                                            <a (click)="viewStudSettings(this.studentId)">
                                                <i class="feather-settings"></i>
                                                <span>{{'Settings' | translate}}</span>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul class="user-list-wrapper">
                                        <li>
                                            <a (click)="logout()">
                                                <i class="feather-log-out"></i>
                                                <span>{{'Logout' | translate}}</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>

                        <li class="access-icon rbt-user-wrapper right-align-dropdown d-block d-xl-none">
                            <a class="rbt-round-btn"><i class="feather-user"></i></a>
                            <div class="rbt-user-menu-list-wrapper">
                                <div class="inner">
                                    <div class="rbt-admin-profile">
                                        <div class="admin-thumbnail">
                                            <img style="aspect-ratio: 1 / 1;" [src]="this.baseService.appUrl + this.profileImg" onerror=" this.onerror=null;this.src='assets/images/team/avatar.jpg';" alt="User Images">
                                        </div>
                                        <div class="admin-info">
                                            <span class="name">{{this.userFullName}}</span>
                                            <a class="rbt-btn-link color-primary"
                                                (click)="viewStudProfile(this.studentId)">{{'View Profile' |
                                                translate}}</a>
                                        </div>
                                    </div>
                                    <hr class="mt--10 mb--10">
                                    <ul class="user-list-wrapper">
                                        <li>
                                            <a (click)="viewStudCourses(this.studentId)">
                                                <i class="feather-monitor"></i>
                                                <span>{{'Courses' | translate}}</span>
                                            </a>
                                        </li>
                                    </ul>
                                    <!-- <ul class="user-list-wrapper">
                                        <li>
                                            <a (click)="viewWishlist(this.studentId)">
                                                <i class="feather-heart"></i>
                                                <span>{{'fav' | translate}}</span>
                                            </a>
                                        </li>
                                    </ul> -->
                                    <ul class="user-list-wrapper">
                                        <li>
                                            <a (click)="viewCart()">
                                                <i class="feather-shopping-cart"></i>
                                                <span>{{'cart' | translate}}</span>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul class="user-list-wrapper">
                                        <li>
                                            <a (click)="viewStudSettings(this.studentId)">
                                                <i class="feather-settings"></i>
                                                <span>{{'Settings' | translate}}</span>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul class="user-list-wrapper">
                                        <li>
                                            <a (click)="logout()">
                                                <i class="feather-log-out"></i>
                                                <span>{{'Logout' | translate}}</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>


                    <ul class="quick-access" *ngIf="this.isTeacher === 'true'">
                        <li class="access-icon rbt-mini-cart" (click)="showNotificationSide()">
                            <a class="rbt-cart-sidenav-activation rbt-round-btn">
                                <i class="feather-bell" style="margin-left: 0px !important;"></i>
                                <span class="rbt-cart-count">{{teacherNotificationsNo}}</span>
                            </a>
                        </li>

                        <li class="account-access rbt-user-wrapper right-align-dropdown d-none d-xl-block">
                            <a><i class="feather-user"></i>{{'account' | translate}}</a>
                            <div class="rbt-user-menu-list-wrapper">
                                <div class="inner">
                                    <div class="rbt-admin-profile">
                                        <div class="admin-thumbnail">
                                            <img style="aspect-ratio: 1 / 1;" [src]="this.baseService.appUrl + this.profileImg" onerror=" this.onerror=null;this.src='assets/images/team/avatar.jpg';" alt="User Images">
                                        </div>
                                        <div class="admin-info">
                                            <span class="name">{{this.userFullName}}</span>
                                            <a class="rbt-btn-link color-primary"
                                                (click)="viewProfile(this.teacherId)">{{'View Profile' | translate}}</a>
                                        </div>
                                    </div>
                                    <ul class="user-list-wrapper">
                                        <li>
                                            <a (click)="viewCourses(this.teacherId)">
                                                <i class="feather-monitor"></i>
                                                <span>{{'MyCourses' | translate}}</span>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul class="user-list-wrapper">
                                        <li>
                                            <a (click)="ViewPayments(this.teacherId)">
                                                <i class="feather-dollar-sign"></i>
                                                <span>{{'payments' | translate}}</span>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul class="user-list-wrapper">
                                        <li>
                                            <a (click)="viewSettings(this.teacherId)">
                                                <i class="feather-settings"></i>
                                                <span>{{'Settings' | translate}}</span>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul class="user-list-wrapper">
                                        <li>
                                            <a (click)="logout()">
                                                <i class="feather-log-out"></i>
                                                <span>{{'Logout' | translate}}</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>

                        <li class="access-icon rbt-user-wrapper right-align-dropdown d-block d-xl-none">
                            <a class="rbt-round-btn"><i class="feather-user"></i></a>
                            <div class="rbt-user-menu-list-wrapper">
                                <div class="inner">
                                    <div class="rbt-admin-profile">
                                        <div class="admin-thumbnail">
                                            <img style="aspect-ratio: 1 / 1;" [src]="this.baseService.appUrl + this.profileImg" onerror=" this.onerror=null;this.src='assets/images/team/avatar.jpg';" alt="User Images">
                                        </div>
                                        <div class="admin-info">
                                            <span class="name">{{this.userFullName}}</span>
                                            <a class="rbt-btn-link color-primary"
                                                (click)="viewProfile(this.teacherId)">{{'View Profile' | translate}}</a>
                                        </div>
                                    </div>
                                    <hr class="mt--10 mb--10">
                                    <ul class="user-list-wrapper">
                                        <li>
                                            <a (click)="viewCourses(this.teacherId)">
                                                <i class="feather-monitor"></i>
                                                <span>{{'MyCourses' | translate}}</span>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul class="user-list-wrapper">
                                        <li>
                                            <a (click)="ViewPayments(this.teacherId)">
                                                <i class="feather-dollar-sign"></i>
                                                <span>{{'payments' | translate}}</span>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul class="user-list-wrapper">
                                        <li>
                                            <a (click)="viewSettings(this.teacherId)">
                                                <i class="feather-settings"></i>
                                                <span>{{'Settings' | translate}}</span>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul class="user-list-wrapper">
                                        <li>
                                            <a (click)="logout()">
                                                <i class="feather-log-out"></i>
                                                <span>{{'Logout' | translate}}</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>

<div class="popup-mobile-menu" *ngIf="!loader">
    <div class="inner-wrapper">
        <div class="inner-top">
            <div class="content">
                <div class="logo" routerLink="/home">
                    <a>
                        <img src="assets/images/logo/learnyhomelogo.png" alt="Education Logo Images"
                            style="width: 80%;">
                    </a>
                </div>
                <div class="rbt-btn-close" (click)="hideMobilemenu()">
                    <button class="close-button rbt-round-btn"><i class="feather-x"></i></button>
                </div>
            </div>
            <br>
            <ul class="navbar-top-left rbt-information-list justify-content-start">
                <li>
                    <a href="mailto:hello@example.com"><i class="feather-mail"></i>Info@LearnyHome.com</a>
                </li>
                <li>
                    <a><i class="feather-phone"></i>966114501055+</a>
                </li>
            </ul>
        </div>

        <nav class="mainmenu-nav">
            <ul class="mainmenu">
                <li class="position-static">
                    <a routerLink="/home">{{'home' | translate}}</a>
                </li>

                <li class="position-static">
                    <a routerLink="/courses">{{'Courses' | translate}}</a>
                </li>

                <li class="position-static">
                    <a routerLink="/about-us">{{'About Us' | translate}}</a>
                </li>

                <li class="position-static">
                    <a routerLink="/contact">{{'Contact Us' | translate}}</a>
                </li>
            </ul>
        </nav>

        <div class="mobile-menu-bottom">
            <div class="rbt-btn-wrapper mb--20" *ngIf="!tokenValid" routerLink="/register">
                <a
                    class="rbt-btn btn-gradient radius-round btn-sm hover-transform-none w-100 justify-content-center text-center">
                    <span>{{'Join Now' | translate}}</span>
                </a>
            </div>

            <div class="rbt-btn-wrapper mb--20" style="margin-top: 10px;" routerLink="/login" *ngIf="!tokenValid">
                <a
                    class="rbt-btn btn-gradient radius-round btn-sm hover-transform-none w-100 justify-content-center text-center">
                    <span>{{'signIn' | translate}}</span>
                </a>
            </div>

            <div class="social-share-wrapper">
                <span class="rbt-short-title d-block">{{'followUs' | translate}}</span>
                <ul class="social-icon social-default transparent-with-border justify-content-start mt--20">
                    <li><a href="https://www.facebook.com/">
                            <i class="feather-facebook"></i>
                        </a>
                    </li>
                    <li><a href="https://www.twitter.com">
                            <i class="feather-twitter"></i>
                        </a>
                    </li>
                    <li><a href="https://www.instagram.com/">
                            <i class="feather-instagram"></i>
                        </a>
                    </li>
                    <li><a href="https://www.linkdin.com/">
                            <i class="feather-linkedin"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>


<div class="rbt-cart-side-menu" *ngIf="!loader">
    <div class="inner-wrapper" style="justify-content: normal;">
        <div class="inner-top">
            <div class="content">
                <div class="title">
                    <h4 class="title mb--0">{{'noti' | translate}}</h4>
                </div>
                <div class="rbt-btn-close" id="btn_sideNavClose" (click)="closeNotification()">
                    <button class="minicart-close-button rbt-round-btn"><i class="feather-x"></i></button>
                </div>
            </div>
        </div>
        <nav class="side-nav w-100">
            <ul class="rbt-minicart-wrapper" *ngIf="this.isTeacher === 'true'">
                <li class="minicart-item" *ngFor="let notifi of teacherNotifications">
                    <div class="product-content">
                        <h4 class="title">
                            <div class="iconNewSub">
                                <i class="feather-user-plus" *ngIf="notifi.title === ''"></i>
                                <i class="feather-star" *ngIf="notifi.title === 'Start Tomorrow'"></i>
                                <i class="feather-x-circle" *ngIf="notifi.title === 'Ends Tomorrow'"></i>
                                <i class="feather-dollar-sign" *ngIf="notifi.title === 'Confirm Payment'" (click)="ViewPayments(this.teacherId)"></i>
                            </div> 
                            <a *ngIf="notifi.title === ''">{{'newEnrollment' | translate}}</a>
                            <a *ngIf="notifi.title === 'Start Tomorrow'">{{'startTom' | translate}}</a>
                            <a *ngIf="notifi.title === 'Ends Tomorrow'">{{'endTom' | translate}}</a>
                            <a *ngIf="notifi.title === 'Confirm Payment'" (click)="ViewPayments(this.teacherId)">{{'endTom' | translate}}</a>
                        </h4>
                        <!-- <span style="font-size: 13px;">قام الطالب محمد بالاشتراك في الدورة الخاص بك</span> -->
                        <span *ngIf="notifi.title === 'Start Tomorrow'" style="font-size: 13px;">{{'TheCourse' | translate}} "{{notifi.courseName}}" {{'startsTomrrow' | translate}}</span>
                        <span *ngIf="notifi.title === 'Ends Tomorrow'" style="font-size: 13px;">{{'TheCourse' | translate}} "{{notifi.courseName}}" {{'endsTomrrow' | translate}}</span>
                        <span *ngIf="notifi.title === 'Confirm Payment'" style="font-size: 13px;cursor: pointer;" (click)="ViewPayments(this.teacherId)">{{'newPayment' | translate}} "{{notifi.courseName}}"</span>
                    </div>
                    <!-- <div class="close-btn">
                        <i class="feather-clock"></i> <span style="font-size: 12px; margin-left: 5px;">PM 12:00</span>
                    </div> -->
                </li>
            </ul>
            <ul class="rbt-minicart-wrapper" *ngIf="this.isTeacher === 'false'">
                <li class="minicart-item" *ngFor="let notifi of studNotifications">
                    <div class="product-content">
                        <h4 class="title">
                            <div class="iconNewSub">
                                <i class="feather-user-plus" *ngIf="notifi.title === ''"></i>
                                <i class="feather-star" *ngIf="notifi.title === 'Start Tomorrow'"></i>
                                <i class="feather-x-circle" *ngIf="notifi.title === 'Ends Tomorrow'"></i>
                            </div> 
                            <a *ngIf="notifi.title === ''">{{'newEnrollment' | translate}}</a>
                            <a *ngIf="notifi.title === 'Start Tomorrow'">{{'startTom' | translate}}</a>
                            <a *ngIf="notifi.title === 'Ends Tomorrow'">{{'endTom' | translate}}</a>
                        </h4>
                        <!-- <span style="font-size: 13px;">قام الطالب محمد بالاشتراك في الدورة الخاص بك</span> -->
                        <span *ngIf="notifi.title === 'Start Tomorrow'" style="font-size: 13px;">{{'TheCourse' | translate}} "{{notifi.courseName}}" {{'startsTomrrow' | translate}}</span>
                        <span *ngIf="notifi.title === 'Ends Tomorrow'" style="font-size: 13px;">{{'TheCourse' | translate}} "{{notifi.courseName}}" {{'endsTomrrow' | translate}}</span>
                    </div>
                    <!-- <div class="close-btn">
                        <i class="feather-clock"></i> <span style="font-size: 12px; margin-left: 5px;">PM 12:00</span>
                    </div> -->
                </li>
            </ul>
        </nav>
        <!-- <div class="rbt-minicart-footer">
            <hr class="mb--0">
            <div class="rbt-minicart-bottom mt--20">
                <div class="checkout-btn mt--20">
                    <a class="rbt-btn btn-gradient icon-hover w-100 text-center">
                        <span class="btn-text">مشاهدة جميع الاشعارات</span>
                        <span class="btn-icon"><i class="feather-arrow-right"></i></span>
                    </a>
                </div>
            </div>
        </div> -->
    </div>
</div>

<!-- <block-ui> -->
<router-outlet (activate)="onActive()" *ngIf="!loader"></router-outlet>
<!-- </block-ui> -->

<footer class="rbt-footer footer-style-1 bg-color-white overflow-hidden" style="border-top: 1px solid #DDD;" *ngIf="!loader">
    <div class="footer-top">
        <div class="container">
            <div class="row g-5">
                <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                    <div class="footer-widget">
                        <div class="logo">
                            <a>
                                <img src="assets/images/logo/learnyhomelogo.png" alt="Edu-cause">
                            </a>
                        </div>

                        <p class="description mt--20">{{'headerslogan' | translate}}
                        </p>

                        <ul class="social-icon social-default justify-content-start">
                            <li><a href="https://www.facebook.com/">
                                    <i class="feather-facebook"></i>
                                </a>
                            </li>
                            <li><a href="https://www.twitter.com">
                                    <i class="feather-twitter"></i>
                                </a>
                            </li>
                            <li><a href="https://www.instagram.com/">
                                    <i class="feather-instagram"></i>
                                </a>
                            </li>
                            <li><a href="https://www.linkdin.com/">
                                    <i class="feather-linkedin"></i>
                                </a>
                            </li>
                        </ul>

                        <div class="contact-btn mt--30">
                            <a class="rbt-btn hover-transform-none btn-border-gradient radius-round" routerLink="/contact">
                                <div class="icon-reverse-wrapper">
                                    <span class="btn-text">{{'Contact Us' | translate}}</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-2 col-md-6 col-sm-6 col-12">
                    <div class="footer-widget">
                    </div>
                </div>

                <div class="col-lg-2 col-md-6 col-sm-6 col-12">
                    <div class="footer-widget">
                        <h5 class="ft-title">{{'Useful Links' | translate}}</h5>
                        <ul class="ft-link">
                            <li>
                                <a routerLink="/home">{{'home' | translate}}</a>
                            </li>
                            <li>
                                <a routerLink="/courses">{{'Courses' | translate}}</a>
                            </li>
                            <li>
                                <a routerLink="/about-us">{{'About Us' | translate}}</a>
                            </li>

                            <li>
                                <a routerLink="/contact">{{'Contact Us' | translate}}</a>
                            </li>
                            <li>
                                <a routerLink="/faqs">{{'FAQ' | translate}}</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                    <div class="footer-widget">
                        <h5 class="ft-title">{{'Get Contact' | translate}}</h5>
                        <ul class="ft-link">
                            <li><span>{{'Phone' | translate}}: </span> <a href="tel:+966114501055">(966) 114501055</a>
                            </li>
                            <li><span>{{'Email' | translate}}: </span> <a
                                    href="mailto:Admin@learnyhome.com">Admin@learnyhome.com</a></li>
                        </ul>

                        <form class="newsletter-form mt--20" action="#">
                            <h6 class="w-600">{{'Full Address' | translate}}</h6>
                            <p class="description">{{'address' | translate}}</p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="rbt-separator-mid">
        <div class="container">
            <hr class="rbt-separator m-0">
        </div>
    </div>

    <div class="copyright-area copyright-style-1 ptb--20">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-12">
                    <p class="rbt-link-hover text-center">{{'Copyright' | translate}} © 2023 <a
                            href="https://aldawal.com/Home" target="_blank">Aldawal</a></p>
                </div>
            </div>
        </div>
    </div>

</footer>

<div class="whatsapp-icon" *ngIf="!loader">
    <a href="https://wa.me/966114501055" class="ico-out" target="_blank"></a>
    <span id="simple-chat-button--text">{{'Contact Us' | translate}}</span>
</div>